/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcOrdersV1OrderEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_ORDERS_V1_ORDER_EVENT_ENTITY_NAME = 'ixc.orders.v1.OrderEvent';
export const ixcOrdersV1OrderEventEntity = new schema.Entity<IxcOrdersV1OrderEvent>(IXC_ORDERS_V1_ORDER_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        requested: new schema.Object({
            batchOrderContext: new schema.Object({
                asset: ixcAssetsV1AssetStateEntity
            })
        })
    })
}, { idAttribute: (entity: IxcOrdersV1OrderEvent) => `${entity.metadata?.eventId}` });

